//----------------------
// <auto-generated>
//     Generated using the NSwag toolchain v13.20.0.0 (NJsonSchema v11.0.0.0 (Newtonsoft.Json v13.0.0.0)) (http://NSwag.org)
// </auto-generated>
//----------------------

/* tslint:disable */
/* eslint-disable */
// ReSharper disable InconsistentNaming
import * as Types from '../api-client.types';
import { useQuery, useMutation } from '@tanstack/react-query';
import type { UseQueryResult, QueryFunctionContext, UseQueryOptions, QueryClient, QueryKey, MutationKey, UseMutationOptions, UseMutationResult, QueryMeta, MutationMeta } from '@tanstack/react-query';
import { trimArrayEnd, isParameterObject, getBaseUrl, addMetaToOptions } from './helpers';
import type { QueryMetaContextValue } from 'react-query-swagger';
import { QueryMetaContext } from 'react-query-swagger';
import { useContext } from 'react';
import * as Client from './DoctorClient'
export { Client };
import type { AxiosRequestConfig } from 'axios';

export type GetDoctorDoctorQueryParameters = {
  id: number ;
}

export type EditDoctorDoctorQueryParameters = {
  id: number ;
}

export type RemoveDoctorDoctorQueryParameters = {
  id: number ;
}

export type GetDoctorsDoctorQueryParameters = {
  all?: boolean | undefined ;
  doctorType?: Types.DoctorType | null | undefined ;
  doctorIds?: number[] | null | undefined ;
  doctorCisIds?: string[] | null | undefined ;
  searchQuery?: string | null | undefined ;
  isOnlyActive?: boolean | null | undefined ;
  doctorImportIds?: string[] | null | undefined ;
  includeDeleted?: boolean | null | undefined ;
  isUsedAsResource?: boolean | null | undefined ;
  pagination_Offset?: number | undefined ;
  pagination_Limit?: number | undefined ;
  sorting_SortField?: string | null | undefined ;
  sorting_SortDirection?: Types.SortDirection | undefined ;
  additionalSorting?: Types.SortingDto[] | null | undefined ;
}

export function getDoctorUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/doctors/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDoctorDefaultOptions: Omit<UseQueryOptions<Types.DoctorDto, unknown, Types.DoctorDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.DoctorDto, unknown, Types.DoctorDto>, 'queryFn'>> = {
};
export function getGetDoctorDefaultOptions() {
  return getDoctorDefaultOptions;
};
export function setGetDoctorDefaultOptions(options: typeof getDoctorDefaultOptions) {
  getDoctorDefaultOptions = options;
}

export function getDoctorQueryKey(id: number): QueryKey;
export function getDoctorQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { id,  } = params[0] as GetDoctorDoctorQueryParameters;

    return trimArrayEnd([
        'DoctorClient',
        'getDoctor',
        id as any,
      ]);
  } else {
    return trimArrayEnd([
        'DoctorClient',
        'getDoctor',
        ...params
      ]);
  }
}
export function __getDoctor(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDoctor(
      context.queryKey[2] as number,axiosConfig    );
}

export function useGetDoctorQuery<TSelectData = Types.DoctorDto, TError = unknown>(dto: GetDoctorDoctorQueryParameters, options?: Omit<UseQueryOptions<Types.DoctorDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets a doctor by id.
 * @param id The doctor id.
 */
export function useGetDoctorQuery<TSelectData = Types.DoctorDto, TError = unknown>(id: number, options?: Omit<UseQueryOptions<Types.DoctorDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDoctorQuery<TSelectData = Types.DoctorDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.DoctorDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let id: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ id,  } = params[0] as GetDoctorDoctorQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [id, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.DoctorDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDoctor(context, axiosConfig) : __getDoctor,
    queryKey: getDoctorQueryKey(id),
    ...getDoctorDefaultOptions as unknown as Omit<UseQueryOptions<Types.DoctorDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets a doctor by id.
 * @param id The doctor id.
 */
export function setGetDoctorData(queryClient: QueryClient, updater: (data: Types.DoctorDto | undefined) => Types.DoctorDto, id: number) {
  queryClient.setQueryData(getDoctorQueryKey(id),
    updater
  );
}

/**
 * Gets a doctor by id.
 * @param id The doctor id.
 */
export function setGetDoctorDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.DoctorDto | undefined) => Types.DoctorDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function editDoctorUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/doctors/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function editDoctorMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DoctorClient',
      'editDoctor',
      id as any,
    ]);
}

/**
 * Edits a doctor.
 * @param id The doctor id.
 * @param updatedDoctor Request parameter
 */
export function useEditDoctorMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, Types.UpdateDoctorDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, Types.UpdateDoctorDto, TContext> {
  const key = editDoctorMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (updatedDoctor: Types.UpdateDoctorDto) => Client.editDoctor(id, updatedDoctor),
    mutationKey: key,
  });
}
  
type EditDoctor__MutationParameters = EditDoctorDoctorQueryParameters & {
  updatedDoctor: Types.UpdateDoctorDto;
}

/**
 * Edits a doctor.
 * @param id The doctor id.
 * @param updatedDoctor Request parameter
 */
export function useEditDoctorMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, EditDoctor__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: EditDoctorDoctorQueryParameters}): UseMutationResult<void, unknown, EditDoctor__MutationParameters, TContext> {
  const key = editDoctorMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: EditDoctor__MutationParameters) => Client.editDoctor(data.id ?? options?.parameters?.id!, data.updatedDoctor),
  mutationKey: key,
});
}
  
export function removeDoctorUrl(id: number): string {
  let url_ = getBaseUrl() + "/api/doctors/{id}";
if (id === undefined || id === null)
  throw new Error("The parameter 'id' must be defined.");
url_ = url_.replace("{id}", encodeURIComponent("" + id));
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function removeDoctorMutationKey(id: number): MutationKey {
  return trimArrayEnd([
      'DoctorClient',
      'removeDoctor',
      id as any,
    ]);
}

/**
 * Removes a doctor.
 * @param id The doctor id.
 */
export function useRemoveDoctorMutation<TContext>(id: number, options?: Omit<UseMutationOptions<void, unknown, void, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<void, unknown, void, TContext> {
  const key = removeDoctorMutationKey(id);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: () => Client.removeDoctor(id),
    mutationKey: key,
  });
}
  
type RemoveDoctor__MutationParameters = RemoveDoctorDoctorQueryParameters

/**
 * Removes a doctor.
 * @param id The doctor id.
 */
export function useRemoveDoctorMutationWithParameters<TContext>(options?: Omit<UseMutationOptions<void, unknown, RemoveDoctor__MutationParameters, TContext>, 'mutationKey' | 'mutationFn'> & { parameters?: RemoveDoctorDoctorQueryParameters}): UseMutationResult<void, unknown, RemoveDoctor__MutationParameters, TContext> {
  const key = removeDoctorMutationKey(options?.parameters?.id!);
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
return useMutation({
  ...options, 
  mutationFn: (data: RemoveDoctor__MutationParameters) => Client.removeDoctor(data.id ?? options?.parameters?.id!),
  mutationKey: key,
});
}
  
export function getDoctorsUrl(all?: boolean | undefined, doctorType?: Types.DoctorType | null | undefined, doctorIds?: number[] | null | undefined, doctorCisIds?: string[] | null | undefined, searchQuery?: string | null | undefined, isOnlyActive?: boolean | null | undefined, doctorImportIds?: string[] | null | undefined, includeDeleted?: boolean | null | undefined, isUsedAsResource?: boolean | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): string {
  let url_ = getBaseUrl() + "/api/doctors?";
if (all === null)
    throw new Error("The parameter 'all' cannot be null.");
else if (all !== undefined)
    url_ += "all=" + encodeURIComponent("" + all) + "&";
if (doctorType !== undefined && doctorType !== null)
    url_ += "DoctorType=" + encodeURIComponent("" + doctorType) + "&";
if (doctorIds !== undefined && doctorIds !== null)
    doctorIds && doctorIds.forEach(item => { url_ += "DoctorIds=" + encodeURIComponent("" + item) + "&"; });
if (doctorCisIds !== undefined && doctorCisIds !== null)
    doctorCisIds && doctorCisIds.forEach(item => { url_ += "DoctorCisIds=" + encodeURIComponent("" + item) + "&"; });
if (searchQuery !== undefined && searchQuery !== null)
    url_ += "SearchQuery=" + encodeURIComponent("" + searchQuery) + "&";
if (isOnlyActive !== undefined && isOnlyActive !== null)
    url_ += "IsOnlyActive=" + encodeURIComponent("" + isOnlyActive) + "&";
if (doctorImportIds !== undefined && doctorImportIds !== null)
    doctorImportIds && doctorImportIds.forEach(item => { url_ += "DoctorImportIds=" + encodeURIComponent("" + item) + "&"; });
if (includeDeleted !== undefined && includeDeleted !== null)
    url_ += "IncludeDeleted=" + encodeURIComponent("" + includeDeleted) + "&";
if (isUsedAsResource !== undefined && isUsedAsResource !== null)
    url_ += "IsUsedAsResource=" + encodeURIComponent("" + isUsedAsResource) + "&";
if (pagination_Offset === null)
    throw new Error("The parameter 'pagination_Offset' cannot be null.");
else if (pagination_Offset !== undefined)
    url_ += "Pagination.Offset=" + encodeURIComponent("" + pagination_Offset) + "&";
if (pagination_Limit === null)
    throw new Error("The parameter 'pagination_Limit' cannot be null.");
else if (pagination_Limit !== undefined)
    url_ += "Pagination.Limit=" + encodeURIComponent("" + pagination_Limit) + "&";
if (sorting_SortField !== undefined && sorting_SortField !== null)
    url_ += "Sorting.SortField=" + encodeURIComponent("" + sorting_SortField) + "&";
if (sorting_SortDirection === null)
    throw new Error("The parameter 'sorting_SortDirection' cannot be null.");
else if (sorting_SortDirection !== undefined)
    url_ += "Sorting.SortDirection=" + encodeURIComponent("" + sorting_SortDirection) + "&";
if (additionalSorting !== undefined && additionalSorting !== null)
    additionalSorting && additionalSorting.forEach((item, index) => {
        for (let attr in item)
			if (item.hasOwnProperty(attr)) {
				url_ += "AdditionalSorting[" + index + "]." + attr + "=" + encodeURIComponent("" + (item as any)[attr]) + "&";
			}
    });
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

let getDoctorsDefaultOptions: Omit<UseQueryOptions<Types.PageableListDtoOfDoctorListDto, unknown, Types.PageableListDtoOfDoctorListDto>, 'queryKey' | 'queryFn'> & Partial<Pick<UseQueryOptions<Types.PageableListDtoOfDoctorListDto, unknown, Types.PageableListDtoOfDoctorListDto>, 'queryFn'>> = {
};
export function getGetDoctorsDefaultOptions() {
  return getDoctorsDefaultOptions;
};
export function setGetDoctorsDefaultOptions(options: typeof getDoctorsDefaultOptions) {
  getDoctorsDefaultOptions = options;
}

export function getDoctorsQueryKey(dto: GetDoctorsDoctorQueryParameters): QueryKey;
export function getDoctorsQueryKey(all?: boolean | undefined, doctorType?: Types.DoctorType | null | undefined, doctorIds?: number[] | null | undefined, doctorCisIds?: string[] | null | undefined, searchQuery?: string | null | undefined, isOnlyActive?: boolean | null | undefined, doctorImportIds?: string[] | null | undefined, includeDeleted?: boolean | null | undefined, isUsedAsResource?: boolean | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined): QueryKey;
export function getDoctorsQueryKey(...params: any[]): QueryKey {
  if (params.length === 1 && isParameterObject(params[0])) {
    const { all, doctorType, doctorIds, doctorCisIds, searchQuery, isOnlyActive, doctorImportIds, includeDeleted, isUsedAsResource, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetDoctorsDoctorQueryParameters;

    return trimArrayEnd([
        'DoctorClient',
        'getDoctors',
        all as any,
        doctorType as any,
        doctorIds as any,
        doctorCisIds as any,
        searchQuery as any,
        isOnlyActive as any,
        doctorImportIds as any,
        includeDeleted as any,
        isUsedAsResource as any,
        pagination_Offset as any,
        pagination_Limit as any,
        sorting_SortField as any,
        sorting_SortDirection as any,
        additionalSorting as any,
      ]);
  } else {
    return trimArrayEnd([
        'DoctorClient',
        'getDoctors',
        ...params
      ]);
  }
}
export function __getDoctors(context: QueryFunctionContext, axiosConfig?: AxiosRequestConfig | undefined) {
  return Client.getDoctors(
      context.queryKey[2] as boolean | undefined,       context.queryKey[3] as Types.DoctorType | null | undefined,       context.queryKey[4] as number[] | null | undefined,       context.queryKey[5] as string[] | null | undefined,       context.queryKey[6] as string | null | undefined,       context.queryKey[7] as boolean | null | undefined,       context.queryKey[8] as string[] | null | undefined,       context.queryKey[9] as boolean | null | undefined,       context.queryKey[10] as boolean | null | undefined,       context.queryKey[11] as number | undefined,       context.queryKey[12] as number | undefined,       context.queryKey[13] as string | null | undefined,       context.queryKey[14] as Types.SortDirection | undefined,       context.queryKey[15] as Types.SortingDto[] | null | undefined,axiosConfig    );
}

export function useGetDoctorsQuery<TSelectData = Types.PageableListDtoOfDoctorListDto, TError = unknown>(dto: GetDoctorsDoctorQueryParameters, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDoctorListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
/**
 * Gets doctors.
 * @param all (optional) Get all doctors without filtering
 * @param doctorType (optional) 
 * @param doctorIds (optional) 
 * @param doctorCisIds (optional) 
 * @param searchQuery (optional) 
 * @param isOnlyActive (optional) 
 * @param doctorImportIds (optional) 
 * @param includeDeleted (optional) 
 * @param isUsedAsResource (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function useGetDoctorsQuery<TSelectData = Types.PageableListDtoOfDoctorListDto, TError = unknown>(all?: boolean | undefined, doctorType?: Types.DoctorType | null | undefined, doctorIds?: number[] | null | undefined, doctorCisIds?: string[] | null | undefined, searchQuery?: string | null | undefined, isOnlyActive?: boolean | null | undefined, doctorImportIds?: string[] | null | undefined, includeDeleted?: boolean | null | undefined, isUsedAsResource?: boolean | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined, options?: Omit<UseQueryOptions<Types.PageableListDtoOfDoctorListDto, TError, TSelectData>, 'queryKey'>, axiosConfig?: Partial<AxiosRequestConfig>): UseQueryResult<TSelectData, TError>;
export function useGetDoctorsQuery<TSelectData = Types.PageableListDtoOfDoctorListDto, TError = unknown>(...params: any []): UseQueryResult<TSelectData, TError> {
  let options: UseQueryOptions<Types.PageableListDtoOfDoctorListDto, TError, TSelectData> | undefined = undefined;
  let axiosConfig: AxiosRequestConfig |undefined = undefined;
  let all: any = undefined;
  let doctorType: any = undefined;
  let doctorIds: any = undefined;
  let doctorCisIds: any = undefined;
  let searchQuery: any = undefined;
  let isOnlyActive: any = undefined;
  let doctorImportIds: any = undefined;
  let includeDeleted: any = undefined;
  let isUsedAsResource: any = undefined;
  let pagination_Offset: any = undefined;
  let pagination_Limit: any = undefined;
  let sorting_SortField: any = undefined;
  let sorting_SortDirection: any = undefined;
  let additionalSorting: any = undefined;
  
  if (params.length > 0) {
    if (isParameterObject(params[0])) {
      ({ all, doctorType, doctorIds, doctorCisIds, searchQuery, isOnlyActive, doctorImportIds, includeDeleted, isUsedAsResource, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting,  } = params[0] as GetDoctorsDoctorQueryParameters);
      options = params[1];
      axiosConfig = params[2];
    } else {
      [all, doctorType, doctorIds, doctorCisIds, searchQuery, isOnlyActive, doctorImportIds, includeDeleted, isUsedAsResource, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting, options, axiosConfig] = params;
    }
  }

  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);

  return useQuery<Types.PageableListDtoOfDoctorListDto, TError, TSelectData>({
    queryFn: axiosConfig ? (context) => __getDoctors(context, axiosConfig) : __getDoctors,
    queryKey: getDoctorsQueryKey(all, doctorType, doctorIds, doctorCisIds, searchQuery, isOnlyActive, doctorImportIds, includeDeleted, isUsedAsResource, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    ...getDoctorsDefaultOptions as unknown as Omit<UseQueryOptions<Types.PageableListDtoOfDoctorListDto, TError, TSelectData>, 'queryKey'>,
    ...options,
  });
}
/**
 * Gets doctors.
 * @param all (optional) Get all doctors without filtering
 * @param doctorType (optional) 
 * @param doctorIds (optional) 
 * @param doctorCisIds (optional) 
 * @param searchQuery (optional) 
 * @param isOnlyActive (optional) 
 * @param doctorImportIds (optional) 
 * @param includeDeleted (optional) 
 * @param isUsedAsResource (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetDoctorsData(queryClient: QueryClient, updater: (data: Types.PageableListDtoOfDoctorListDto | undefined) => Types.PageableListDtoOfDoctorListDto, all?: boolean | undefined, doctorType?: Types.DoctorType | null | undefined, doctorIds?: number[] | null | undefined, doctorCisIds?: string[] | null | undefined, searchQuery?: string | null | undefined, isOnlyActive?: boolean | null | undefined, doctorImportIds?: string[] | null | undefined, includeDeleted?: boolean | null | undefined, isUsedAsResource?: boolean | null | undefined, pagination_Offset?: number | undefined, pagination_Limit?: number | undefined, sorting_SortField?: string | null | undefined, sorting_SortDirection?: Types.SortDirection | undefined, additionalSorting?: Types.SortingDto[] | null | undefined) {
  queryClient.setQueryData(getDoctorsQueryKey(all, doctorType, doctorIds, doctorCisIds, searchQuery, isOnlyActive, doctorImportIds, includeDeleted, isUsedAsResource, pagination_Offset, pagination_Limit, sorting_SortField, sorting_SortDirection, additionalSorting),
    updater
  );
}

/**
 * Gets doctors.
 * @param all (optional) Get all doctors without filtering
 * @param doctorType (optional) 
 * @param doctorIds (optional) 
 * @param doctorCisIds (optional) 
 * @param searchQuery (optional) 
 * @param isOnlyActive (optional) 
 * @param doctorImportIds (optional) 
 * @param includeDeleted (optional) 
 * @param isUsedAsResource (optional) 
 * @param pagination_Offset (optional) 
 * @param pagination_Limit (optional) 
 * @param sorting_SortField (optional) 
 * @param sorting_SortDirection (optional) 
 * @param additionalSorting (optional) 
 */
export function setGetDoctorsDataByQueryId(queryClient: QueryClient, queryKey: QueryKey, updater: (data: Types.PageableListDtoOfDoctorListDto | undefined) => Types.PageableListDtoOfDoctorListDto) {
  queryClient.setQueryData(queryKey, updater);
}
    
export function createDoctorUrl(): string {
  let url_ = getBaseUrl() + "/api/doctors";
  url_ = url_.replace(/[?&]$/, "");
  return url_;
}

export function createDoctorMutationKey(): MutationKey {
  return trimArrayEnd([
      'DoctorClient',
      'createDoctor',
    ]);
}

/**
 * Creates a doctor.
 * @param newDoctor Request parameter
 */
export function useCreateDoctorMutation<TContext>(options?: Omit<UseMutationOptions<Types.DoctorDto, unknown, Types.CreateDoctorDto, TContext>, 'mutationKey' | 'mutationFn'>): UseMutationResult<Types.DoctorDto, unknown, Types.CreateDoctorDto, TContext> {
  const key = createDoctorMutationKey();
  
  const metaContext = useContext(QueryMetaContext);
  options = addMetaToOptions(options, metaContext);
  
  return useMutation({
    ...options,
    mutationFn: (newDoctor: Types.CreateDoctorDto) => Client.createDoctor(newDoctor),
    mutationKey: key,
  });
}